export enum PatientProfileCheckKinds {
  None = 0,                   // 設定対象にしない.
  TrueOrFalse = 1,            // TRUE,FALSEを設定.
  defaultChecked = 2,         // 初期選択値を設定.
  defaultCheckedOrEmpty = 3,  // 初期選択値を設定(未選択時は空).
}
